import { Link as RouterLink } from 'react-router-dom';
import { Button } from 'src/components/Button';
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
} from 'src/components/Card';
import { Icon, IconDefinition } from 'src/components/Icon';
import { Link } from 'src/components/Link';
import { Typography } from 'src/components/Typography';

interface ActionCardProps {
  title: string | React.ReactNode | (() => React.ReactNode);
  description: string | React.ReactNode;
  buttonText?: string;
  icon?: IconDefinition;
  onClick?: () => void;
  to?: string;
  href?: string;
  buttonOnClick?: () => void;
}

export const ActionCard: React.FC<ActionCardProps> = ({
  title,
  description,
  buttonText,
  icon,
  onClick,
  to,
  href,
  buttonOnClick,
}) => (
  <Card elevation={0} sx={{ bgcolor: 'background.level1', height: '100%' }}>
    <CardActionArea
      onClick={onClick}
      component={to ? RouterLink : href ? Link : 'div'}
      to={to}
      href={href}
      sx={{
        textDecoration: 'none',
        '&:hover': { textDecoration: 'none' },
        height: '100%',
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {typeof title === 'function' ? title() : title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
      </CardContent>

      <CardActions sx={{ p: 2, pt: 0 }}>
        <Button
          size="small"
          endIcon={icon ? <Icon size="small" icon={icon} /> : undefined}
          onClick={buttonOnClick}
        >
          {buttonText}
        </Button>
      </CardActions>
    </CardActionArea>
  </Card>
);
